import { render } from "./Datawallets.vue?vue&type=template&id=fe26914a"
import script from "./Datawallets.vue?vue&type=script&lang=js"
export * from "./Datawallets.vue?vue&type=script&lang=js"

import "./Datawallets.vue?vue&type=style&index=0&id=fe26914a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Datawallets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe26914a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe26914a', __exports__)) {
    api.reload('fe26914a', __exports__)
  }
  
  module.hot.accept("./Datawallets.vue?vue&type=template&id=fe26914a", () => {
    api.rerender('fe26914a', render)
  })

}


export default __exports__